import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, Select, List, Icon, Popconfirm } from 'antd'

import moment from 'moment'

@inject((store: any) => {
    const { popupStore, collectionTypesStore } = store
    return { popupStore, collectionTypesStore }
})
@observer
export default class Servicefield extends Component<any, any> {
    state: any = {
        errors: {}
    }

    handleSubmit = async () => {
        const { addCollectionType, updateCollectionType, editCollectionType } = this.props.collectionTypesStore
        if (editCollectionType.id === 'add') {
            await addCollectionType()
        } else {
            await updateCollectionType()
        }
    }

    render() {
        const { collectionType } = this.props
        const {
            error,
            editCollectionType,
            toggleCollectionType,
            editValue,
            resetEdit,
            deleteCollectionType
        } = this.props.collectionTypesStore
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: '0.7rem 0.5rem',
                    backgroundColor: `${editCollectionType.id === collectionType.id ? '#f0f2f5' : 'initial'}`
                }}
            >
                <div
                    style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}
                    onClick={() => toggleCollectionType(collectionType)}
                >
                    {collectionType.id === 'add' ? (
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                color: '#e77910',
                                textDecoration: 'underline',
                                width: '100%'
                            }}
                        >
                            <Icon type={editCollectionType.id === 'add' ? 'down' : 'left'} />
                            <span style={{ marginRight: '0.5rem' }}>הוסף תחום שירות חדש +</span>
                        </div>
                    ) : (
                        <Fragment>
                            <div>
                                <span style={{ marginLeft: '0.5rem' }}>
                                    <Icon type={editCollectionType.id === collectionType.id ? 'down' : 'left'} />
                                </span>
                                {collectionType['id']} - {collectionType['name']} (
                                {collectionType['__meta__']['related_collections']} זכויות)
                            </div>
                            <div>
                                {collectionType['updated_by'] ? collectionType['updated_by'] : 'כל הבריאות'}
                                {collectionType['updated_at']
                                    ? ` | ${moment(collectionType['updated_at']).format('DD/MM/YYYY')}`
                                    : ''}
                            </div>
                        </Fragment>
                    )}
                </div>
                {editCollectionType.id === collectionType.id ? (
                    <div style={{ padding: '0.5rem 0.2rem 0.2rem', display: 'flex', flexDirection: 'column' }}>
                        {collectionType['updated_by'] || collectionType.id === 'add' ? (
                            <Fragment>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Input
                                        value={editCollectionType.name}
                                        placeholder="הזן שם תחום שירות"
                                        onChange={e => editValue('name', e.target.value)}
                                    />
                                    <Button
                                        disabled={
                                            !editCollectionType.name || editCollectionType.name === collectionType.name
                                        }
                                        style={{ margin: '0 0.2rem' }}
                                        onClick={() => resetEdit()}
                                    >
                                        <Icon type="stop" />
                                    </Button>
                                    <Popconfirm
                                        disabled={
                                            !editCollectionType.name || editCollectionType.name === collectionType.name
                                        }
                                        onConfirm={() => this.handleSubmit()}
                                        okText="אישור"
                                        cancelText="ביטול"
                                        title={`האם ${editCollectionType.id === 'add' ? 'להוסיף' : 'לעדכן'} סוג זה?`}
                                    >
                                        <Button
                                            style={{ margin: '0' }}
                                            disabled={
                                                !editCollectionType.name ||
                                                editCollectionType.name === collectionType.name
                                            }
                                            type="primary"
                                        >
                                            <Icon type="check" />
                                        </Button>
                                    </Popconfirm>
                                </div>
                                <div>
                                    {collectionType['updated_by'] ? (
                                        <Popconfirm
                                            onConfirm={() => deleteCollectionType()}
                                            okText="אישור"
                                            cancelText="ביטול"
                                            title={`הסרת סוג זה תסיר את הקשר בין הסוג לזכויות האם בכל זאת למחוק זה?`}
                                        >
                                            <Icon type="delete" />
                                            <a style={{ textDecoration: 'underline' }}>הסר סוג</a>
                                        </Popconfirm>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </Fragment>
                        ) : (
                            <span>תחום שירות זה הורד במקור מאתר כל הבריאות ולא ניתן לעריכה</span>
                        )}
                        {error ? <span style={{ color: 'red', fontWeight: 'bold' }}>{error}</span> : ''}
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }
}
